module.exports = __webpack_public_path__ + "img/54000.9abeb77b.jpg";